import React from 'react'
import './information.scss';
import Marker from '../../interfaces/Marker';

export interface IProps{
    information: any,
    markers: Marker[]
}

const Information = ({information, markers}: IProps) => {

    const _mountArrayRatingStars = (value: number, levelColor: string) => {
        const stars: any[] = [];
        let valueAux = value;
     
        for (let count = 0; count < 5; count++) {
          if (valueAux > 0.5) {
            stars.push(<i key={count} style={{color: levelColor}} className={"fa fa-star "}></i>);
          } else if (valueAux === 0.5) {
            stars.push(<i key={count} style={{color: levelColor}} className={"fa fa-star-half "}></i>);
          } else {
            stars.push(<i key={count} style={{color: levelColor}} className={"fa fa-star-o "}></i>);
          }
     
          valueAux -= 1;
        }
     
        return stars;
      }

     const _renderScore = (score: number = 0, levelColor: string = '') =>  {

        return (
          <div className="container-stars">
            {_mountArrayRatingStars(score, levelColor).map((ele) => ele)}
          </div>
        );
      }

    return (
        <div className="wrapper-distance-information">                      
              <div className="information-block"><span>LEVEL:</span> {markers.length == 0 ? '--' : _renderScore(information?.score, information?.levelColor)}</div>
              <div className="information-block"><span>Accumulated Distance:</span> <b>{information?.travelledDistance ? information?.travelledDistance?.toFixed(2) + ' Km' : '--'}</b></div>
              <div className="information-block"><span>Accumulated Time:</span> <b>{information?.travelledTime || '--:--:--'}</b></div>
              <div className="information-block"><span>Instantaneous velocity:</span> <b>{information?.speed ? information.speed.toFixed(1) + ' Km/h' : '--'}</b></div>
              <div className="information-block"><span>ADDRESS:</span> <b>{information?.address || '--'}</b></div>
        </div>
    );
}

export default Information;
